import { render, staticRenderFns } from "./required-editor.vue?vue&type=template&id=0800aa0e&scoped=true"
import script from "./required-editor.vue?vue&type=script&lang=js"
export * from "./required-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0800aa0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0800aa0e')) {
      api.createRecord('0800aa0e', component.options)
    } else {
      api.reload('0800aa0e', component.options)
    }
    module.hot.accept("./required-editor.vue?vue&type=template&id=0800aa0e&scoped=true", function () {
      api.rerender('0800aa0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/required-editor.vue"
export default component.exports